// Where the user is in the viewer, for the Session panel's messages
// (claude-docs/2026-10-26-page-to-session-design.md, "Context the page
// sends") and the in-app chat's (features/chatLoop/), in every build. The
// viewer publishes; the panel and the chat read at send time. A plain module
// store, because both live outside the viewer's React tree.

let context = {};
const subscribers = new Set();

export function publishPageContext(partial) {
  context = { ...context, ...partial };
  for (const fn of subscribers) fn(context);
}

export const getPageContext = () => context;

export function subscribePageContext(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}

/** The viewer has gone: nothing on the page says where the user is. */
export function clearPageContext() {
  context = {};
  for (const fn of subscribers) fn(context);
}
